export default {
  subscribe: "اشترك",
  subscribeText: "ابقَ على اطلاع بأحدث الدورات والعروض من SkillSynergy.",
  submit: "إرسال",
  sending: "جارٍ الإرسال...",
  success: "تم الاشتراك!",
  failed: "فشل!",
};
